import { twMerge } from "tailwind-merge";
import { clsx, type ClassValue } from "clsx";

/** shadcn's version of classNames(), well-suited for Tailwind CSS merging
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
